import { render, staticRenderFns } from "./datewiseCapture.vue?vue&type=template&id=1c371c54&"
import script from "./datewiseCapture.vue?vue&type=script&lang=js&"
export * from "./datewiseCapture.vue?vue&type=script&lang=js&"
import style0 from "./datewiseCapture.vue?vue&type=style&index=0&id=1c371c54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports